import { fetchReceiptData } from "@/services/receipt.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";

function formattedDateToTime(date: string) {
  const newDate = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  }).format(new Date(date));

  return newDate;
}

function formattedDateToString(date: string) {
  const dateType = new Date(date);
  return dateType.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export const useReceipt = (receiptID: string) => {
  const { notify } = useToastNotify();
  const t = useT();

  const [errorNotified, setErrorNotified] = useState(false);

  const { data, isPending, isError, error } = useQuery({
    queryKey: ["receipt", receiptID],
    queryFn: () => fetchReceiptData({ receiptID }),
    enabled: !!receiptID,
    retry: false,
  });

  if (isError && !errorNotified) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching receipt data"),
    });
    console.error("Error fetching receipt data:", error);
    setErrorNotified(true);
  }
  if (!isError && errorNotified) {
    setErrorNotified(false);
  }

  const formattedStartTime = data?.receipt.startTime ? formattedDateToTime(data.receipt.startTime) : "";
  const formattedEndTime = data?.receipt.endTime ? formattedDateToTime(data.receipt.endTime) : "";
  const formattedDate = data?.receipt.startTime ? formattedDateToString(data.receipt.startTime) : "";
  const parsedAllowPlateSwitchUntil = data?.receipt.allowPlateSwitchUntil ? Date.parse(data.receipt.allowPlateSwitchUntil) : new Date(0);

  return {
    receipt: data?.receipt,
    isPending,
    formattedStartTime,
    formattedEndTime,
    formattedDate,
    parsedAllowPlateSwitchUntil,
  };
};
